module.exports = __webpack_public_path__ + "img/about-4.388dc2b1.png";